export default {
  SHOW_NOTIFICATION: 'showNotification',
  HIDE_NOTIFICATION: 'hideNotification',
};
